import classNames from 'classnames'
import Avatar from '../../avatar'

type PatientOverviewCardProps = {
  name: string;
  availability?: string;
  isSelected: boolean;
  onClick: () => void;
};

const PractitionerOverviewCard = ({
  name,
  availability,
  isSelected,
  onClick,
}: PatientOverviewCardProps) => {
  return (
    <div
      onClick={onClick}
      className={classNames('w-full bg-white shadow-default', {
        'shadow-focus-large transition-all': isSelected,
        'cursor-pointer': onClick,
      })}
    >
      <div className="flex flex-col justify-between h-full p-4 tablet:p-6 gap-x-3 tablet:flex-row">
        <div className="flex gap-3 fitems-center">
          <div className="flex-shrink-0">
            <Avatar
              name={name}
              className="w-[60px] h-[60px] tablet:w-[72px] tablet:h-[72px]"
            />
          </div>

          <div className="self-center">
            <h3 className="text-lg leading-[18px] font-semibold">
              {name}
            </h3>
          </div>
        </div>

        {availability && (
          <div className="mt-4 tablet:hidden">
            <span className="text-grey-dark text-tablet leading-[24px] font-semibold">
              Availability:{' '}
            </span>
            <span className="text-grey-dark leading-[24px] font-normal">
              {availability}
            </span>
          </div>
        )}
      </div>
    </div>
  )
}

export default PractitionerOverviewCard
